import { inject, Injectable } from '@angular/core';
import { AmplitudeService } from '@brighthub/logging';
import { accountDetailKind } from '../account-path-type';

/**
 * Amplitude events for Accounts inventory and detail.
 * Never send balances, last-4, account ids, client GUIDs, institution names,
 * or raw API status strings.
 */
@Injectable({ providedIn: 'root' })
export class AccountsAnalytics {
  private readonly _amplitude = inject(AmplitudeService);

  viewed(totalAccounts: number): void {
    this._amplitude.logEvent('account_inventory_viewed', {
      total_accounts: totalAccounts,
      app: 'brightnav',
    });
  }

  /** Overlay successfully rendered. `accountType` is mapped to a closed kind. */
  detailOpened(accountType: string): void {
    this._amplitude.logEvent('account_detail_opened', {
      account_type: accountDetailKind(accountType),
      app: 'brightnav',
    });
  }
}
